import React from 'react';
import { Dialog, RadioButton } from 'material-ui';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';

const SyncDialog = props => {
  const {
    open,
    loading,
    onRequestClose,
    onConfirm,
    value,
    syncRatesToo,
    labelText,
    dontSyncRates,
    checkSyncRates,
    currentlySynced,
    isAccom,
  } = props;
  return (
    <Dialog
      open={open}
      contentStyle={{ width: '450px' }}
      onRequestClose={onRequestClose}
      actions={[
        <FlatButton
          label="cancel"
          primary
          disabled={loading}
          onTouchTap={onRequestClose}
        />,
        <FlatButton
          label="confirm"
          secondary
          onTouchTap={onConfirm}
          loader={loading}
        />,
      ]}
    >
      {
        (() => {
          if (currentlySynced) {
            return (
              <i>
                {labelText} are currently synced. Once turned off, changes will not be synced the next time you edit {labelText}.
              </i>
            );
          }
          if (value === 'seasons') {
            return (
              <div>
                <label>Please select what you would like to sync to other products:</label>
                <RadioButton
                  label="Seasons"
                  checked={!syncRatesToo}
                  onCheck={dontSyncRates}
                />
                <RadioButton
                  label="Seasons with Rates"
                  checked={syncRatesToo}
                  onCheck={checkSyncRates}
                />
                <br />
                <i>
                  Please note that by proceeding with this change existing {!syncRatesToo ? 'SEASON' : 'SEASON & RATES'} in other&nbsp;
                  {isAccom ? 'rooms' : 'products'} will be overwritten.
                </i>
              </div>
            );
          }
          return <i>Please note that by proceeding with this change existing {labelText} in other {isAccom ? 'rooms' : 'products'} will be overwritten.</i>;
        })()
      }
    </Dialog>
  );
};

SyncDialog.propTypes = {
  open: React.PropTypes.bool,
  loading: React.PropTypes.bool,
  onRequestClose: React.PropTypes.func,
  onConfirm: React.PropTypes.func,
  value: React.PropTypes.string,
  syncRatesToo: React.PropTypes.bool,
  labelText: React.PropTypes.string,
  dontSyncRates: React.PropTypes.func,
  checkSyncRates: React.PropTypes.func,
  currentlySynced: React.PropTypes.bool,
  isAccom: React.PropTypes.bool,
};

export default SyncDialog;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/template-draft-toolbar/sync-dialog.jsx